export default __webpack_public_path__ + "static/14-ef3d56d192f94d7db824bfb17ea75652.jpg";